import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "156",
  height: "156",
  viewBox: "0 0 156 156",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"min-width":"156px","min-height":"156px"}
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["fill", "stroke"]
const _hoisted_6 = ["fill", "stroke"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["fill", "stroke"]
const _hoisted_10 = ["fill", "stroke"]
const _hoisted_11 = ["fill", "stroke"]
const _hoisted_12 = ["stroke"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = ["stroke"]
const _hoisted_15 = ["stroke"]
const _hoisted_16 = ["stroke"]
const _hoisted_17 = ["fill", "stroke"]
const _hoisted_18 = ["stroke"]
const _hoisted_19 = ["stroke"]
const _hoisted_20 = ["stroke"]
const _hoisted_21 = ["fill"]
const _hoisted_22 = ["fill"]
const _hoisted_23 = ["fill"]
const _hoisted_24 = ["stroke"]
const _hoisted_25 = ["stroke"]
const _hoisted_26 = ["stroke"]
const _hoisted_27 = ["fill", "stroke"]
const _hoisted_28 = ["fill", "stroke"]
const _hoisted_29 = ["fill", "stroke"]
const _hoisted_30 = ["fill", "stroke"]
const _hoisted_31 = ["fill", "stroke"]
const _hoisted_32 = ["fill", "stroke"]
const _hoisted_33 = ["fill", "stroke"]
const _hoisted_34 = ["fill", "stroke"]
const _hoisted_35 = ["fill", "stroke"]
const _hoisted_36 = ["fill", "stroke"]
const _hoisted_37 = ["fill", "stroke"]
const _hoisted_38 = ["fill", "stroke"]
const _hoisted_39 = ["fill", "stroke"]
const _hoisted_40 = ["stroke"]
const _hoisted_41 = ["stroke"]
const _hoisted_42 = ["fill", "stroke"]
const _hoisted_43 = ["stroke"]
const _hoisted_44 = ["stroke"]
const _hoisted_45 = ["stroke"]
const _hoisted_46 = ["fill", "stroke"]
const _hoisted_47 = ["fill", "stroke"]
const _hoisted_48 = ["fill", "stroke"]
const _hoisted_49 = ["fill", "stroke"]
const _hoisted_50 = ["stroke"]
const _hoisted_51 = ["stroke"]
const _hoisted_52 = ["stroke"]
const _hoisted_53 = ["stroke"]
const _hoisted_54 = ["stroke"]
const _hoisted_55 = ["stroke"]
const _hoisted_56 = ["stroke"]
const _hoisted_57 = ["fill", "stroke"]
const _hoisted_58 = ["fill"]
const _hoisted_59 = ["stroke"]
const _hoisted_60 = ["fill"]
const _hoisted_61 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'HotelLarge',
  props: {
    stroke: {
      type: String,
      required: true,
    },
    fill: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M0 8C0 3.58172 3.58172 0 8 0H148C152.418 0 156 3.58172 156 8V148C156 152.418 152.418 156 148 156H8C3.58172 156 0 152.418 0 148V8Z",
      fill: __props.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M126.151 88.3325V106.015L56.1755 135.935L28.2629 124.015V106.333",
      fill: __props.fill
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M126.151 88.3325V106.015L56.1755 135.935L28.2629 124.015V106.333",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M130.93 90.373L98.2381 76.4121L25.3279 107.585V110.879L57.9729 124.819L130.93 93.6662V90.373Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M122.105 39.7954L115.203 28.7937L119.254 27.0244L126.151 38.0261V88.3324L122.105 90.1017V39.7954Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M126.151 38.0264L122.105 39.7956L126.151 38.0264Z",
      fill: __props.fill
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M126.151 38.0264L122.105 39.7956",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M91.6664 52.7911L84.7695 41.7893L99.3914 35.5474L106.288 46.5491L91.6664 52.7911Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M87.5366 40.6098L92.332 48.2296L100.591 44.7067V39.1641L95.7857 37.0869L87.5366 40.6098Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M114.972 35.2395L106.288 34.9055L98.804 31.7115L98.0284 31.5288L98.804 35.2395L99.391 35.5475L106.288 46.5492L91.666 52.7912V103.097L106.288 96.8555L114.972 97.1895L122.88 93.8128V31.8628L114.972 35.2395Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M106.288 58.0308L91.666 64.2779",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M122.881 54.9777L114.972 58.3544L106.288 58.0256V49.3933L114.972 49.7273L122.881 46.3506",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M106.288 43.8195V35.5474",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M114.972 44.148V35.9229",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_15),
    _createElementVNode("path", {
      d: "M114.972 58.3546V49.7275",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_16),
    _createElementVNode("path", {
      d: "M92.3424 42.6869L100.591 39.164L95.7856 37.0869L99.0769 35.6777L98.8096 35.2393L98.0339 31.5286L119.259 27.0246L105.146 20.9966L35.1599 50.9173L28.2629 67.4982V106.333L56.1755 118.253L75.8548 109.851L84.5388 110.185L92.4472 106.808V44.858L84.5388 48.2347L75.8548 47.9007L73.0981 46.7734L87.5418 40.6045L92.3477 42.6817L92.3424 42.6869Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_17),
    _createElementVNode("path", {
      d: "M70.8337 54.67L75.8544 56.815L84.5385 57.1438L92.4416 53.7671",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_18),
    _createElementVNode("path", {
      d: "M92.4419 67.9735L84.5388 71.3502L75.8547 71.0214V62.3892",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_19),
    _createElementVNode("path", {
      d: "M72.8042 61.0889L75.8544 62.3884L84.5384 62.7224L92.4415 59.3457",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_20),
    _createElementVNode("path", {
      d: "M95.562 67.8341L102.085 65.0351V74.6538L95.562 77.4528V67.8341Z",
      fill: __props.fill
    }, null, 8, _hoisted_21),
    _createElementVNode("path", {
      d: "M95.562 86.0117L102.085 83.2127V92.8314L95.562 95.6304V86.0117Z",
      fill: __props.fill
    }, null, 8, _hoisted_22),
    _createElementVNode("path", {
      d: "M95.562 54.4572L102.085 51.6582V59.8208L95.562 62.6198V54.4572Z",
      fill: __props.fill
    }, null, 8, _hoisted_23),
    _createElementVNode("path", {
      d: "M95.562 67.8341L102.085 65.0351V74.6538L95.562 77.4528V67.8341Z",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_24),
    _createElementVNode("path", {
      d: "M95.562 86.0117L102.085 83.2127V92.8314L95.562 95.6304V86.0117Z",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_25),
    _createElementVNode("path", {
      d: "M95.562 54.4572L102.085 51.6582V59.8208L95.562 62.6198V54.4572Z",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_26),
    _createElementVNode("path", {
      d: "M45.8245 80.2065L38.6079 77.1533V86.7668L45.8245 89.8199V80.2065Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_27),
    _createElementVNode("path", {
      d: "M45.8245 98.3847L38.6079 95.3315V104.945L45.8245 107.998V98.3847Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_28),
    _createElementVNode("path", {
      d: "M44.7453 62.3001L39.6931 60.1655V72.3989L44.7453 74.5387V62.3001Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_29),
    _createElementVNode("path", {
      d: "M62.4697 81.4329L69.6863 78.3745V87.9932L62.4697 91.0463V81.4329Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_30),
    _createElementVNode("path", {
      d: "M62.4697 99.6111L69.6863 96.5527V106.171L62.4697 109.225V99.6111Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_31),
    _createElementVNode("path", {
      d: "M84.4604 76.8349L89.3982 74.6943V84.3078L84.4604 86.4484V76.8349Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_32),
    _createElementVNode("path", {
      d: "M114.898 63.8451L119.836 61.7046V71.3181L114.898 73.4586V63.8451Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_33),
    _createElementVNode("path", {
      d: "M84.4604 95.0126L89.3982 92.8721V102.486L84.4604 104.626V95.0126Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_34),
    _createElementVNode("path", {
      d: "M114.898 82.0229L119.836 79.8823V89.4958L114.898 91.6363V82.0229Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_35),
    _createElementVNode("path", {
      d: "M77.7048 77.0298L81.1323 77.1603V86.7737L77.7048 86.6485V77.0298Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_36),
    _createElementVNode("path", {
      d: "M77.7048 95.207L81.1323 95.3375V104.951L77.7048 104.826V95.207Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_37),
    _createElementVNode("path", {
      d: "M108.148 64.0391L111.571 64.1695V73.783L108.148 73.6577V64.0391Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_38),
    _createElementVNode("path", {
      d: "M108.148 82.2168L111.571 82.3473V91.9607L108.148 91.8355V82.2168Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_39),
    _createElementVNode("path", {
      d: "M75.8547 56.8146V48.5425",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_40),
    _createElementVNode("path", {
      d: "M84.5383 57.1437V48.9185",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_41),
    _createElementVNode("path", {
      d: "M123.761 27.9222C122.64 27.4421 121.591 26.0486 120.947 24.8639C120.302 23.6792 119.7 23.0007 118.809 22.6928L113.542 20.4434L107.431 20.2085L101.865 22.5832C100.964 23.032 100.329 23.5956 99.6324 24.7491C98.6891 26.3148 97.5256 27.2594 96.5823 27.7552L97.4575 31.9409L105.9 35.5472L115.701 35.923L124.626 32.1131L123.761 27.9222Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_42),
    _createElementVNode("path", {
      d: "M84.5383 71.3502V62.7231",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_43),
    _createElementVNode("path", {
      d: "M106.288 49.3938V46.5494L103.95 42.8178L106.288 43.8199L114.972 44.1487L122.88 40.772",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_44),
    _createElementVNode("path", {
      d: "M28.2629 67.5039L56.1755 79.4242",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_45),
    _createElementVNode("path", {
      d: "M33.3252 74.8569V84.4704L33.9829 84.7496V75.1348L33.3252 74.8569Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_46),
    _createElementVNode("path", {
      d: "M33.3252 92.9956V102.609L33.9829 102.888V93.2735L33.3252 92.9956Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_47),
    _createElementVNode("path", {
      d: "M50.4497 82.2417V91.8552L51.1074 92.1344V82.5196L50.4497 82.2417Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_48),
    _createElementVNode("path", {
      d: "M50.4497 100.381V109.994L51.1074 110.274V100.659L50.4497 100.381Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_49),
    _createElementVNode("path", {
      d: "M75.8547 127.522V117.184",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_50),
    _createElementVNode("path", {
      d: "M56.1755 135.935V124.051",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_51),
    _createElementVNode("path", {
      d: "M91.666 110.43V120.758",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_52),
    _createElementVNode("path", {
      d: "M106.288 104.188V114.506",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_53),
    _createElementVNode("path", {
      d: "M40.9087 117.533V129.417",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_54),
    _createElementVNode("path", {
      d: "M56.1755 118.253V79.4238",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_55),
    _createElementVNode("path", {
      d: "M67.5898 44.5244L68.3707 48.2351L68.9525 48.5431L75.8546 71.0214L56.1753 79.4241L49.2732 56.9457L35.1597 50.9177",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_56),
    _createElementVNode("path", {
      d: "M93.3224 40.9227C92.2009 40.4426 91.1527 39.0491 90.5081 37.8644C89.8635 36.6796 89.2608 36.0012 88.3699 35.6932L83.1028 33.4438L76.992 33.209L71.4263 35.5836C70.5249 36.0325 69.8907 36.5961 69.1937 37.7495C68.2504 39.3153 67.0869 40.2599 66.1436 40.7557L67.0188 44.9414L75.4617 48.5477L85.2621 48.9235L94.1872 45.1136L93.312 40.9279L93.3224 40.9227Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_57),
    _createElementVNode("path", {
      d: "M54.9912 54.5077L59.8914 69.6168L68.1509 66.0992V53.062L63.2403 50.9849",
      fill: __props.fill
    }, null, 8, _hoisted_58),
    _createElementVNode("path", {
      d: "M54.9912 54.5077L59.8914 69.6168L68.1509 66.0992V53.062L63.2403 50.9849",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_59),
    _createElementVNode("path", {
      d: "M49.2734 56.9451L54.9912 54.5078L59.9071 56.585L68.1509 53.0622L63.2402 50.985L68.9527 48.5425",
      fill: __props.fill
    }, null, 8, _hoisted_60),
    _createElementVNode("path", {
      d: "M49.2734 56.9451L54.9912 54.5078L59.9071 56.585L68.1509 53.0622L63.2402 50.985L68.9527 48.5425",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_61)
  ]))
}
}

})